
import { Target, Calendar, TrendingUp } from 'lucide-react';

const HowItWorksSection = () => {
  const steps = [
    {
      step: 1,
      title: "Create your PACT",
      description: "Define what you want to show up for and for how many days",
      icon: Target
    },
    {
      step: 2,
      title: "Show up daily",
      description: "Mark your daily progress and build momentum",
      icon: Calendar
    },
    {
      step: 3,
      title: "Celebrate consistency",
      description: "See your progress and enjoy the practice you've built",
      icon: TrendingUp
    }
  ];

  return (
    <section className="bg-white py-20">
      <div className="container max-w-6xl mx-auto px-4">
        <h3 className="text-3xl font-bold text-center text-deep-blue mb-4">
          As Simple as 1, 2, 3
        </h3>
        <p className="text-center text-deep-blue/70 mb-16 text-lg max-w-2xl mx-auto">
          No complex setups or overwhelming features. Just focus on what matters.
        </p>
        
        <div className="grid md:grid-cols-3 gap-12">
          {steps.map((item, index) => (
            <div key={index} className="text-center group">
              <div className="relative mb-6">
                <div className="w-20 h-20 bg-gradient-to-r from-vibrant-orange to-vibrant-orange/80 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto group-hover:scale-110 transition-transform duration-300 shadow-lg">
                  {item.step}
                </div>
                <div className="absolute inset-0 w-20 h-20 bg-vibrant-orange rounded-full mx-auto animate-ping opacity-20"></div>
              </div>
              <div className="w-12 h-12 bg-soft-blue text-deep-blue rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-vibrant-orange group-hover:text-white transition-all duration-300">
                <item.icon className="w-6 h-6" />
              </div>
              <h4 className="text-xl font-semibold text-deep-blue mb-3">{item.title}</h4>
              <p className="text-deep-blue/70 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
